// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2731":"9b240a72","6805":"9b240a72","9650":"a5efab46"}[chunkId] + ".chunk.css";
};